module.exports = __webpack_public_path__ + "static/media/popup.2b272daa.jpeg";